<template>
  <div class="py-2 w-full">
    <template v-if="expandable">
      <textarea
        type="text"
        class="w-full px-4 text-sm md:text-base border-1 border-brand-background-light-blue shadow-sm rounded placeholder-brand-mid-gray focus:border-brand-green focus:ring-brand-green"
        :placeholder="placeholder"
        :value="value"
        :class="{ 'bg-brand-light-gray': entered }"
        @blur="checkEntered"
        rows="1"
        ref="textarea"
        :required="required"
        :disabled="disabled"
        autocomplete="off"
        data-private
        style="resize: none"
        :maxlength="maxLength"
      />
    </template>
    <template v-else>
      <input
        :type="type"
        ref="input"
        name="input"
        class="w-full px-4 text-sm md:text-base border-1 border-brand-background-light-blue shadow-sm rounded placeholder-brand-mid-gray focus:border-brand-green focus:ring-brand-green"
        :placeholder="placeholder"
        :class="{ 'bg-brand-light-gray': entered }"
        :value="value"
        @blur="checkEntered"
        v-maska="mask ? maskMap[mask] : ''"
        :required="required"
        :disabled="disabled"
        autocomplete="off"
        data-private
        :maxlength="maxLength"
      />
    </template>
  </div>
</template>
<script>
export default {
  props: {
    expandable: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String
    },
    value: {
      type: String
    },
    type: {
      type: String,
      default: "text"
    },
    mask: {
      type: String
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    maxLength: {
      type: Number,
      default: 524288
    }
  },
  watch: {
    value: {
      handler(val) {
        this.entered = !!val
        if (!this.$refs.textarea || !this.expandable) {
          return
        }

        this.resizeTextarea()
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      entered: false,
      maskMap: {
        phone: "(###) ###-####",
        ssn: "###-##-####",
        zipcode: "#####",
        date: "##/##/####",
        email: "",
        number: "#*",
        currency: "$#*.##"
      }
    }
  },
  methods: {
    resizeTextarea() {
      const { textarea } = this.$refs
      textarea.style.height = "auto"

      this.$nextTick(() => {
        textarea.style.height = textarea.scrollHeight + "px"
      })
    },
    checkEntered() {
      this.entered = !!this.value
      this.$emit("blur")
    }
  }
}
</script>
<style lang="scss"></style>
